module.exports = __webpack_public_path__ + "static/media/item_5_36_comp.e010b140.png";